/**
 * Preview Utils - Génération d'aperçus partiels
 * Version avec champs structurés (adresses décomposées)
 */

/**
 * Tronque le texte à un maximum de caractères
 */
export const truncateText = (text, maxChars = 350) => {
  if (!text || text.length <= maxChars) return text;
  
  let truncated = text.substring(0, maxChars);
  const lastSpace = truncated.lastIndexOf(' ');
  const lastPeriod = truncated.lastIndexOf('.');
  
  if (lastPeriod > maxChars - 50) {
    truncated = text.substring(0, lastPeriod + 1);
  } else if (lastSpace > 0) {
    truncated = text.substring(0, lastSpace);
  }
  
  return truncated + '...';
};

/**
 * Message de verrouillage HTML
 */
export const getLockedContentHtml = () => {
  return `
    <div style="margin-top: 25px; padding: 20px; background: linear-gradient(to bottom, rgba(241, 245, 249, 0.8), rgba(241, 245, 249, 1)); border-radius: 8px; text-align: center;">
      <div style="display: inline-flex; align-items: center; gap: 8px; color: #475569; font-size: 14px; font-weight: 500;">
        <span style="font-size: 18px;">🔒</span>
        <span>Suite du document disponible après téléchargement du PDF.</span>
      </div>
    </div>
  `;
};

/**
 * Formate une date en français
 */
export const formatDateFr = (date) => {
  const d = date instanceof Date ? date : new Date(date || Date.now());
  const months = ["janvier", "février", "mars", "avril", "mai", "juin", 
                  "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
  return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
};

/**
 * Construit l'adresse formatée depuis les champs structurés
 */
export const buildAddressHtml = (ligne1, ligne2, codePostal, ville) => {
  const parts = [];
  if (ligne1) parts.push(ligne1);
  if (ligne2) parts.push(ligne2);
  if (codePostal || ville) parts.push(`${codePostal || ''} ${ville || ''}`.trim());
  return parts.join('<br/>');
};

/**
 * Construit l'adresse formatée en texte
 */
export const buildAddressText = (ligne1, ligne2, codePostal, ville) => {
  const parts = [];
  if (ligne1) parts.push(ligne1);
  if (ligne2) parts.push(ligne2);
  if (codePostal || ville) parts.push(`${codePostal || ''} ${ville || ''}`.trim());
  return parts.join(', ');
};

/**
 * Génère un aperçu HTML partiel avec structure normalisée
 */
export const generatePartialPreviewHtml = ({
  nom = 'NOM',
  prenom = 'Prénom',
  adresse_ligne1 = '',
  adresse_ligne2 = '',
  code_postal = '',
  ville = '',
  dateStr = '',
  lieu = '',
  title = 'Document',
  content = '',
  introText = ''
}) => {
  const truncatedContent = truncateText(content, 350);
  const fullName = `${prenom} ${nom.toUpperCase()}`;
  const addressHtml = buildAddressHtml(adresse_ligne1, adresse_ligne2, code_postal, ville);
  
  return `
    <div style="font-family: 'Public Sans', Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; line-height: 1.6;">
      <div style="text-align: left; margin-bottom: 30px;">
        <strong>${fullName}</strong><br/>
        ${addressHtml}
      </div>
      
      ${lieu && dateStr ? `
      <div style="text-align: right; margin-bottom: 20px;">
        ${lieu}, le ${dateStr}
      </div>
      ` : dateStr ? `
      <div style="text-align: right; margin-bottom: 20px;">
        Le ${dateStr}
      </div>
      ` : ''}
      
      <h2 style="text-align: center; font-size: 18px; margin: 30px 0; text-transform: uppercase;">
        ${title}
      </h2>
      
      <div style="text-align: justify;">
        ${introText ? `<p>${introText}</p>` : ''}
        <p style="color: #334155;">${truncatedContent}</p>
      </div>
      
      ${getLockedContentHtml()}
    </div>
  `;
};
